import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-172" data-mp="3mf7pges1bkaz">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-173" data-mp="3r78y7qpzusw9">
        <SectionTag icon="⭐" tone="accent" data-id="element-174" data-mp="3r9lnyq1zu7jv">
          Testimonios reales
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-175" data-mp="y4kfnbcuey">
          Lo que dicen las profesoras
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-176" data-mp="91mhf70z0oq9">
          <StarRating size={18} data-id="element-177" data-mp="e0z2bm8a7lq7" />
          <span className="text-sm font-medium text-ink" data-id="element-178" data-mp="e18vtjsjcb0n">4.9/5</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-179" data-mp="2au2b9ygpaozl">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl bg-paper p-6 shadow-card-light" data-id="element-180" data-mp="2fslwtxrdtyrf" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-181" data-mp="1et4ma8njv4fh">
              <StarRating size={14} data-id="element-182" data-mp="1euz6fkqzysii" />
              <span className="font-heading text-2xl font-bold text-accent/20" aria-hidden="true" data-id="element-183" data-mp="2bj55ls55gspe">
                "
              </span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-ink" data-id="element-184" data-mp="26kty3o2buuac">"{t.text}"</p>
            <div className="mt-4 flex items-center gap-3 border-t border-primary/10 pt-3" data-id="element-185" data-mp="22hdz4l2schuh">
              <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary" data-id="element-186" data-mp="1xikod0evv4y0">
                {t.initials}
              </div>
              <div data-id="element-187" data-mp="m3fglhzwag7j">
                <p className="text-sm font-semibold text-primary" data-id="element-188" data-mp="m2vzu4lzdxv3">{t.name}</p>
                <p className="text-xs font-medium text-accent" data-id="element-189" data-mp="nmnw6ayfho96">
                  {t.location} {t.flag}
                </p>
              </div>
            </div>
          </m.div>)}
      </div>
    </section>;
}